import _ from 'lodash'
import {Layout} from '../../../layout'
import {Placeholder} from '../../../placeholder'
import {useFilterContext, FiltersPlaceholder} from '../../../filters'
import {AdvancedTableBody, AdvancedTableShowMore} from '../body'
import {AdvancedTableHeader} from '../header'
import {SyncMultiActionStateToTableState} from './components'
import './index.less'

// we need to use 'use no memo' since @tanstack/react-table is not compatible with the react compiler
// see: https://react.dev/reference/eslint-plugin-react-hooks/lints/incompatible-library#invalid and https://github.com/facebook/react/issues/33057
export const AdvancedTable = ({data, placeholderProps, multiAction, ...rest}) => {
	'use no memo' // @tanstack/react-table is not compatible with the react compiler

	const {
		getHeaderGroups,
		getRowModel,
		options: {
			state: {columnVisibility},
		},
	} = data

	const headers = getHeaderGroups()[0]?.headers // we dont use header groups
	const meta = headers[0]?.getContext()?.table?.options?.meta
	const rows = getRowModel().rows

	const allColumnsVisible = _.every(columnVisibility, Boolean)

	const {hasFiltered} = useFilterContext()
	const empty = rows.length == 0
	const placeholder = empty && (hasFiltered ? <FiltersPlaceholder /> : <Placeholder {...placeholderProps} />)

	return (
		<Layout
			className="advanced-table"
			gap={0}
			style={{whiteSpace: 'nowrap'}}
			height="unset"
			block={!placeholder}
			vertical="center"
			horizontal="center"
			{...(placeholder && {width: 'full'})}
		>
			{multiAction && <SyncMultiActionStateToTableState data={data} />}
			{placeholder || (
				<>
					<Layout direction="vertical" borderRight gap={0} style={{verticalAlign: 'top', display: 'inline-flex'}} minHeight="100%">
						<AdvancedTableHeader rows={rows} headers={headers} multiAction={multiAction} {...rest} />
						<AdvancedTableBody meta={meta} rows={rows} multiAction={multiAction} {...rest} />
					</Layout>
					{!allColumnsVisible && <AdvancedTableShowMore {...meta} columnIds={data.options.columnIds} />}
				</>
			)}
		</Layout>
	)
}
